import React from 'react';
import {useIntl} from '@sail/intl';
import {Section, StripeSet, ColumnLayout, Copy} from '@sail/helm';

import {CustomerLogoLinear} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogos/CustomerLogoLinear';
import {CustomerLogoRippling} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogos/CustomerLogoRippling';
import {CustomerLogoRamp} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogos/CustomerLogoRamp';
import {CustomerLogoRetool} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogos/CustomerLogoRetool';
import {CustomerLogoVanta} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogos/CustomerLogoVanta';
import {CustomerLogoOpenAI} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogos/CustomerLogoOpenAI';

import {CustomerLogoGrid} from 'mkt-ssr/components/sail/CustomerLogoGrid/CustomerLogoGrid';
import {CustomerLogo} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogo';
import * as messages from 'mkt-ssr/components/sail/pages/StartupPartners/LeadingStartupSection.messages';

export type LeadingStartupSectionProps = {
  partnerName: string;
};

export const LeadingStartupSection: React.FC<
  React.PropsWithChildren<LeadingStartupSectionProps>
> = ({partnerName}) => {
  const intl = useIntl();
  return (
    <Section theme="white" flavor="chroma" angle="top">
      <StripeSet
        position="top-right"
        stripes={[
          {width: 'full', inset: 'small'},
          {width: 'full', inset: 'normal'},
        ]}
      />
      <ColumnLayout columnsTablet="1" align="center">
        <Copy
          variant="section"
          title={intl.formatMessage(messages.sectionTitle)}
          body={intl.formatMessage(messages.sectionBody, {partnerName})}
        />
        <CustomerLogoGrid orientation="vertical">
          <CustomerLogo logo={CustomerLogoLinear} />
          <CustomerLogo logo={CustomerLogoRippling} />
          <CustomerLogo logo={CustomerLogoRamp} />
          <CustomerLogo logo={CustomerLogoRetool} />
          <CustomerLogo logo={CustomerLogoVanta} />
          <CustomerLogo logo={CustomerLogoOpenAI} />
        </CustomerLogoGrid>
      </ColumnLayout>
    </Section>
  );
};
